export default __webpack_public_path__ + "static/media/logo_white.e7ed43d3.png";